import { render, staticRenderFns } from "./Page404.vue?vue&type=template&id=51259530&scoped=true"
var script = {}
import style0 from "./Page404.vue?vue&type=style&index=0&id=51259530&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51259530",
  null
  
)

export default component.exports